'use strict'

const namespaced = true

const state = {
  modalObjs: []
}

const getters = {
  getModalObjs: state => state.modalObjs
}

const mutations = {
  replaceModal (state, payload) {
    state.modalObjs = payload
  },
  addModal (state, payload) {
    state.modalObjs = [...state.modalObjs, payload]
  },
  hideModal (state, payload) {
    state.modalObjs = state.modalObjs.filter((_obj, idx) => {
      return idx !== payload
    })
  },
  hideAllModal (state, payload) {
    state.modalObjs = []
  }
}

export default {
  namespaced,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/stores/modules/ModalStore.js